/// <reference path="../../../../../../typings/index.d.ts" />

module Meevo.Components.Controls {
    "use strict";

    export class SmartTilePropTicketCountType implements angular.IComponentOptions {
        templateUrl = "app/components/controls/smartCenterDesigner/propertyViews/smartTilePropTicketCountType.component.html";
        bindings: any = {
            prop: '=?',
            selectionChanged: '&?'
        };
        controller = class SmartTilePropTicketCountTypeController {
            static $inject = [
                "meevo.components.common.DataService",
                "$translate"
            ];

            public prop: Meevo.Model.SmartTileParameter;
            public selectedItem: Model.EnumDto;
            public ticketCountTypes: Model.EnumDto[] = [];
            public selectionChanged: Function;

            constructor(
                protected dataService: Components.BaseClasses.IDataService,
                protected $translate: angular.translate.ITranslateService
            ) {
            }

            $onInit(): void {
                this.dataService.getEnumList(Model.EnumTypeEnum.TicketCountTypeEnum).then(ticketCountTypes => {
                    this.ticketCountTypes = [];
                    if (this.prop.includedValues) {
                        const included = this.prop.includedValues.split(',').map(item => item.trim());
                        ticketCountTypes = ticketCountTypes.filter(val => included.indexOf(val.value) !== -1);
                    }
                    this.ticketCountTypes = this.ticketCountTypes.concat(ticketCountTypes);
                    if (this.prop) {
                        this.selectedItem = _.findWhere(this.ticketCountTypes, { value: this.prop.parameterValue });
                    }
                });
            }

            getDisplayName(ticketCountType) {
                switch (ticketCountType.value) {
                    case 'Service':
                        return this.$translate.instant("LABEL_SERVICE");
                    case 'Product':
                        return this.$translate.instant("LABEL_PRODUCT");
                    case 'ServiceProduct':
                        return this.$translate.instant("LABEL_PRODUCT_SERVICE");
                }
            }

            onSelectionChanged(): void {
                this.prop.parameterValue = this.selectedItem.value;
                this.prop.parameterDisplayName = this.selectedItem.displayName;
                this.selectionChanged({ selection: this.selectedItem });
            }
        }
    }

    angular.module("meevo.components.controls")
        .component("stpTicketCountType", new SmartTilePropTicketCountType());
}
